export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8531.ba62a1f2.jpg";